import { Stack } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { QuickAction, useQuickActionsContext } from './quick-actions-context';

export type RegisterQuickActionsOptions = {
  disable?: boolean;
};

const defaultOptions: RegisterQuickActionsOptions = {};

export const useRegisterQuickActions = (
  actions: QuickAction | QuickAction[],
  options?: RegisterQuickActionsOptions,
) => {
  const { addActions, removeActions } = useQuickActionsContext();

  const mergedOptions = useMemo(() => {
    return { ...defaultOptions, ...options };
  }, [options]);

  const disable = useMemo(() => {
    if (mergedOptions.disable) {
      return true;
    }
    return false;
  }, [mergedOptions.disable]);

  const enrichedActions = useMemo(() => {
    return (Array.isArray(actions) ? actions : [actions]).map((action) => ({
      ...action,
      icon: (
        <Stack direction="row" alignItems="center" sx={{ marginRight: '1rem' }}>
          {action.icon}
        </Stack>
      ),
      keywords: [action.title, action.description, ...(action.keywords || [])].filter(
        Boolean,
      ) as string[],
    }));
  }, [actions]);

  useEffect(() => {
    if (disable) {
      return;
    }
    addActions(enrichedActions);
    return () => {
      removeActions(enrichedActions);
    };
  }, [disable, enrichedActions, addActions, removeActions]);
};
